import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["seatIcon", "seatButton"];
  availableText = "空席";
  unavailableText = "売止";
  unavailableClass = "is-stop";

  update() {
    const text = this.seatIconTarget.textContent;
    if (text === this.availableText) {
      this.seatIconTarget.textContent = this.unavailableText;
      this.seatButtonTarget.classList.add(this.unavailableClass);
    } else if (text === this.unavailableText) {
      this.seatIconTarget.textContent = this.availableText;
      this.seatButtonTarget.classList.remove(this.unavailableClass);
    }
  }
}
